<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Update Studio'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-building"></p-inputicon>
                <input
                        pInputText
                        id="studio-name"
                        [(ngModel)]="this.studio.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Studio Name"
                />
            </p-iconfield>
            <label for="studio-name">Studio Name <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-desktop"></p-inputicon>
                <input
                        pInputText
                        id="studio-hostname"
                        [(ngModel)]="this.studio.hostname"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Hostname"
                />
            </p-iconfield>
            <label for="studio-hostname">Hostname</label>
        </p-ifta-label>

        <p-ifta-label>
            <p-inputnumber
                    id="rcps-player-id"
                    [(ngModel)]="this.studio.rcpsPlayerId"
                    class="w-full"
                    mode="decimal"
                    placeholder="RCPS Player ID"
                    minFractionDigits="0"
            ></p-inputnumber>
            <label for="rcps-player-id">RCPS Player ID</label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    id="studio-dealership"
                    [(ngModel)]="this.studio.dealershipId"
                    [options]="availableDealerships"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Dealership"
                    class="w-full"
                    appendTo="body"
                    [disabled]="true"
            ></p-select>
            <label for="studio-dealership">Dealership <span class="text-red-500">*</span></label>
        </p-ifta-label>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>

    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Update"
                icon="pi pi-check"
                (click)="updateStudio()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>
